//MAhesh S:26-10-23 :BT-107375 - Breeze - Scrip -info-events - Start
import { BzChip, BzModal, BzModalBody, BzModalHeader, BzModalTitle } from '../../components';
import { Container, Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from 'react-redux';
import { handleModal } from '../../redux/actions/modals';
import { _getFormattedDate } from '../../controllers/events';

const CorporateActionsDetails = ({ detailedEvent, nCorporateAction }) => {
    const dispatch = useDispatch();
    const modals = useSelector(state => state?.modals?.modals);

    const handleClose = () => {
        dispatch(handleModal([{ "CORPORATE_ACTIONS_DETAILS": false }]));
    };
    //MAhesh S: 20-11-23 :BT-107375 - Breeze - Scrip info events upcoming events changes- Start
    return (
        <BzModal show={modals['CORPORATE_ACTIONS_DETAILS']} onHide={handleClose} size="lg" centered>
            <BzModalHeader className='modaltabs-header modal-header'>
                <Container fluid className='p-0'>
                    <Row className='g-0'>
                        <Col md={11} className='d-flex justify-content-start align-self-center'>
                            {/* Azeem K:02-01-2024 :BT-107375:Breeze- Scrip Info- Events ---Start */}
                            <BzModalTitle className='font-medium font-size4 color-text'>Corporate Action</BzModalTitle>
                            {/* Azeem K:02-01-2024 :BT-107375:Breeze- Scrip Info- Events ---End */}
                        </Col>
                        <Col md={1} className='d-flex justify-content-end align-self-center'>
                            <div className='icon-16 icon-close icon-dark' onClick={handleClose}>&nbsp;</div>
                        </Col>
                    </Row>
                </Container>
            </BzModalHeader>
            <BzModalBody>
                <Container fluid className='p-0'>
                    {detailedEvent?.Upcoming ?
                        // Sumit G - 15-12-23
                        <Row className='g-0'>
                            <Col className='d-flex ipo-chips-wrap'>
                                <BzChip className='chips upcoming-chip mb-2'>UpComing</BzChip>
                            </Col>
                        </Row>
                        : null}
                    <Row className='g-0 mb-2'>
                        <Col>
                            <div className='font-medium font-size5 color-text'>{nCorporateAction?.Title}</div>
                        </Col>
                    </Row>
                    {nCorporateAction?.type === 'book_closure' ?
                        <>
                            <Row className='g-0 mb-3'>
                                <Col>
                                    <div className='font-regular font-size3 color-text'>{_getFormattedDate(detailedEvent?.Announcementdate)}</div>
                                </Col>
                            </Row>
                            <Row className='g-0 mb-2'>
                                <Col>
                                    <div className='font-regular font-size3 color-text'>Duration</div>
                                </Col>
                            </Row>
                            <Row className='g-0 mb-2'>
                                <Col>
                                    <div className='d-flex align-items-center font-regular font-size3 color-text'>{_getFormattedDate(detailedEvent?.BcFromDate)} - {_getFormattedDate(detailedEvent?.BcToDate)}</div>
                                </Col>
                            </Row>
                            <Row className='g-0 mb-2'>
                                <Col className='d-flex flex-row align-self-start'>
                                    <div className='font-regular font-size3 color-text'>Purpose</div>
                                </Col>
                            </Row>
                            <Row className='g-0'>
                                <Col className='d-flex flex-row align-self-start'>
                                    <div className='font-regular font-size3 color-text'>{detailedEvent?.Agenda}</div>
                                </Col>
                            </Row>
                        </>
                        :
                        (nCorporateAction?.type === 'agm' ?
                            <>
                                <Row className='g-0 mb-3'>
                                    <Col>
                                        <div className='font-regular font-size3 color-text'>{_getFormattedDate(detailedEvent?.AnnouncementDate, true)}</div>
                                    </Col>
                                </Row>
                                <Row className='g-0 mb-3'>
                                    <Col>
                                        <div className='font-regular font-size3 color-text'>GM Date</div>
                                        <div className='font-regular font-size3 color-text'>{_getFormattedDate(detailedEvent?.GMDate)}</div>
                                    </Col>
                                </Row>
                                <Row className='g-0 mb-2'>
                                    <Col>
                                        <div className='font-regular font-size3 color-text'>Duration</div>
                                    </Col>
                                </Row>
                                <Row className='g-0 mb-2'>
                                    <Col>
                                        <div className='d-flex align-items-center font-regular font-size3 color-text'>{_getFormattedDate(detailedEvent?.ClosureStartDate)} - {_getFormattedDate(detailedEvent?.ClosureEndDate)}</div>
                                    </Col>
                                </Row>
                                <Row className='g-0 mb-3'>
                                    <Col>
                                        <div className='font-regular font-size3 color-text'>Purpose</div>
                                    </Col>
                                </Row>
                                <Row className='g-0 mb-2'>
                                    <Col>
                                        <div className='font-regular font-size3 color-text'>{detailedEvent?.Description}</div>
                                    </Col>
                                </Row>
                            </>
                            :
                            (nCorporateAction?.type === 'dividend' ?
                                <>
                                    <Row className='g-0'>
                                        <Col>
                                            <div className='font-regular font-size3 color-text'>{detailedEvent?.Divper} %</div>
                                        </Col>
                                    </Row>
                                    <Row className='g-0'>
                                        <Col className='d-flex flex-column align-self-start'>
                                            <div>
                                                <div className='font-regular font-size3 color-text pt-2'>Dividend Type</div>
                                                <div className='font-regular font-size3 color-text pt-2'>{detailedEvent?.Remark}</div>
                                            </div>
                                            <div>
                                                <div className='font-regular font-size3 color-text pt-2'>Recorded Date</div>
                                                <div className='font-regular font-size3 color-text pt-2'>{_getFormattedDate(detailedEvent?.Recorddate)}</div>
                                            </div>
                                            <div>
                                                <div className='font-regular font-size3 color-text pt-2'>Announcement Date</div>
                                                <div className='font-regular font-size3 color-text pt-2'>{_getFormattedDate(detailedEvent?.AnnouncementDate)}</div>
                                            </div>
                                            <div>
                                                <div className='font-regular font-size3 color-text pt-2'>Ex Date</div>
                                                <div className='font-regular font-size3 color-text pt-2'>{_getFormattedDate(detailedEvent?.Divdate)}</div>
                                            </div>
                                            <div>
                                                <div className='font-regular font-size3 color-text pt-2'>Amount</div>
                                                <div className='font-regular font-size3 color-text pt-2'>{detailedEvent?.Divamount}</div>
                                            </div>
                                        </Col>
                                    </Row>
                                </>
                                :
                                (nCorporateAction?.type === 'board_meeting' ?
                                    <>
                                        <Row className='g-0 mb-2'>
                                            <Col>
                                                <div className='font-regular font-size3 color-text'>{_getFormattedDate(detailedEvent?.BMDate)}</div>
                                            </Col>
                                        </Row>
                                        <Row className='g-0 mb-2'>
                                            <div className='font-regular font-size2 color-text text-justify'>{detailedEvent?.Note}</div>
                                        </Row>
                                    </>
                                    :
                                    (nCorporateAction?.type === 'egm' ?
                                        <>
                                            <Row className='g-0 mb-2'>
                                                <Col>
                                                    <div className='font-regular font-size3 color-text'>{_getFormattedDate(detailedEvent?.AnnouncementDate, true)}</div>
                                                </Col>
                                            </Row>
                                            <Row className='g-0 mb-3'>
                                                <Col>
                                                    <div className='font-regular font-size3 color-text'>GM Date</div>
                                                    <div className='font-regular font-size3 color-text'>{_getFormattedDate(detailedEvent?.GMDate)}</div>
                                                </Col>
                                            </Row>
                                            <Row className='g-0 mb-2'>
                                                <Col>
                                                    <div className='font-regular font-size3 color-text'>Purpose</div>
                                                </Col>
                                            </Row>
                                            <Row className='g-0'>
                                                <Col>
                                                    <div className='font-regular font-size3 color-text'>{detailedEvent?.Description}</div>
                                                </Col>
                                            </Row>
                                        </>
                                        :
                                        (nCorporateAction?.type === 'split' ?
                                            <>
                                                <Row className='g-0'>
                                                    <Col>
                                                        <div className='font-medium font-size6 color-text'>{detailedEvent?.Splitratio}</div>
                                                    </Col>
                                                </Row>
                                                <Row className='g-0'>
                                                    <Col className='d-flex flex-column align-self-start'>
                                                        <div>
                                                            <div className='font-regular font-size3 color-text pt-2'>Recorded Date</div>
                                                            {_getFormattedDate(detailedEvent?.Recorddate)}
                                                        </div>
                                                        <div>
                                                            <div className='font-regular font-size3 color-text pt-2'>Announcement Date</div>
                                                            {_getFormattedDate(detailedEvent?.AnnouncementDate)}
                                                        </div>
                                                        <div>
                                                            <div className='font-regular font-size3 color-text pt-2'>Ex Date</div>
                                                            {_getFormattedDate(detailedEvent?.Splitdate)}
                                                        </div>
                                                        <div>
                                                            <div className='font-regular font-size3 color-text pt-2'>Face Value Before</div>
                                                            {detailedEvent?.Fvbefore}
                                                        </div>
                                                        <div>
                                                            <div className='font-regular font-size3 color-text pt-2'>Face Value After</div>
                                                            {detailedEvent?.Fvafter}
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </>
                                            :
                                            (nCorporateAction?.type === 'bonus' ?
                                                <>
                                                    <Row className='g-0'>
                                                        <Col className='d-flex flex-column align-self-start'>
                                                            <div>
                                                                <div className='font-regular font-size3 color-text pt-2'>Bonus Type</div>
                                                                {detailedEvent?.Remark}
                                                            </div>
                                                            <div>
                                                                <div className='font-regular font-size3 color-text pt-2'>Recorded Date</div>
                                                                {_getFormattedDate(detailedEvent?.RecordDate)}
                                                            </div>
                                                            <div>
                                                                <div className='font-regular font-size3 color-text pt-2'>Announcement Date</div>
                                                                {_getFormattedDate(detailedEvent?.AnnoucementDate)}
                                                            </div>
                                                            <div>
                                                                <div className='font-regular font-size3 color-text pt-2'>Ex Date</div>
                                                                {detailedEvent?.BonusDate}
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </>
                                                :
                                                (nCorporateAction?.type === 'rights' ?
                                                    <>
                                                        <Row className='g-0 mb-2'>
                                                            <Col>
                                                                {_getFormattedDate(detailedEvent?.Recorddate)}
                                                            </Col>
                                                        </Row>
                                                        <Row className='g-0 mb-2'>
                                                            <div className='font-regular font-size2 color-text text-justify'>{detailedEvent?.Note || detailedEvent?.Description}</div>
                                                        </Row>
                                                    </> :
                                                    <>
                                                        <Row className='g-0 mb-2'>
                                                            <Col>
                                                                {_getFormattedDate(detailedEvent?.AnnouncementDate || detailedEvent?.AnnoucementDate)}
                                                            </Col>
                                                        </Row>
                                                        <Row className='g-0 mb-2'>
                                                            <div className='font-regular font-size2 color-text text-justify'>{detailedEvent?.Note || detailedEvent?.Description}</div>
                                                        </Row>
                                                    </>)
                                            )
                                        ))
                                )))}
                    {/* //MAhesh S: 20-11-23 :BT-107375 - Breeze - Scrip info events upcoming events changes- Start */}
                </Container>
            </BzModalBody>
        </BzModal>
    );
};

export default CorporateActionsDetails;

//MAhesh S:26-10-23 :BT-107375 - Breeze - Scrip -info-events - End
